import { render, staticRenderFns } from "./DonorSelect.vue?vue&type=template&id=3b74a236&scoped=true&"
import script from "./DonorSelect.vue?vue&type=script&lang=js&"
export * from "./DonorSelect.vue?vue&type=script&lang=js&"
import style0 from "./DonorSelect.vue?vue&type=style&index=0&id=3b74a236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b74a236",
  null
  
)

export default component.exports